module.exports = __webpack_public_path__ + "img/fentanyl.82606b5f.png";